import React from "react";

import Header from "./Header";

const Home = ({ token, name }) => {
  let logToken = window.localStorage.getItem("token");
  console.log("lol", logToken);

  return <Header name={name} />;
};

export default Home;
